export default __webpack_public_path__ + "static/media/e-sport-4.fc82410d.png";